module.exports = "<h1 id=\"两翼留白--m-wing-blank\">两翼留白  m-wing-blank</h1>\n";